import { render, staticRenderFns } from "./MatchingDetail.vue?vue&type=template&id=038b7066&scoped=true&lang=pug"
import script from "./MatchingDetail.vue?vue&type=script&lang=js"
export * from "./MatchingDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchingDetail.vue?vue&type=style&index=0&id=038b7066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b7066",
  null
  
)

export default component.exports